import { AiChatConversation } from '@euler/app/flows/ai-suite/conversation';
import { useServiceFactory } from '@euler/services/factory';
import { useBehaviorSubject, useCreation } from '@euler/utils/hooks';
import { useEffect, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';

// Every turn on a dataset goes to the BI agent; nothing hands off.

/**
 * The dataset's own conversation (**用 AI 分析**): every turn carries the
 * `bi_dataset` page, so the assistant answers about this dataset. Opened
 * the first time the chat is shown.
 */
export function useBiDatasetChat(datasetRef: string) {
  const { aiAssistantService } = useServiceFactory();
  const conversation = useMemo(
    () =>
      new AiChatConversation(aiAssistantService, undefined, {
        page: 'bi_dataset',
        params: { datasetId: datasetRef },
      }),
    [aiAssistantService, datasetRef],
  );
  useEffect(() => () => conversation.dispose(), [conversation]);
  const [state] = useBehaviorSubject(conversation.state$);
  const visible$ = useCreation(() => new BehaviorSubject(false), []);
  const [visible, setVisible] = useBehaviorSubject(visible$);
  const opened = !!state.sessionId || state.loading || !!state.loadError;
  useEffect(() => {
    const { sessionId, loading, loadError } = conversation.state$.getValue();
    if (visible && !loading && (!sessionId || loadError))
      void conversation.openPage();
  }, [visible, conversation]);
  return { conversation, state, opened, visible, setVisible };
}
